import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import KineticMarquee from "@/components/KineticMarquee";
import ManifestoSection from "@/components/ManifestoSection";
import ProgramCurriculum from "@/components/ProgramCurriculum";
import OutcomesBento from "@/components/OutcomesBento";
import BookShowcase from "@/components/BookShowcase";
import SpeakingMediaSection from "@/components/SpeakingMediaSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FacilityInquiryForm from "@/components/FacilityInquiryForm";
import Footer from "@/components/Footer";

export default function LandingPage() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent(r.data))
      .catch(() => setContent({}));
  }, []);

  if (content === null) {
    return (
      <div className="min-h-screen bg-[#0D0E11] flex items-center justify-center" data-testid="landing-loading">
        <div className="font-mono-tactical text-xs tracking-[0.3em] text-amber-500 animate-pulse-amber">S2S LOADING…</div>
      </div>
    );
  }

  return (
    <div className="bg-[#0D0E11] text-[#F3F4F6]" data-testid="landing-page">
      <Header />
      <HeroSection content={content} />
      <KineticMarquee />
      <ManifestoSection content={content} />
      <ProgramCurriculum />
      <OutcomesBento content={content} />
      <BookShowcase content={content} />
      <SpeakingMediaSection />
      <TestimonialsSection content={content} />
      <FacilityInquiryForm />
      <Footer />
    </div>
  );
}
